import styled from "styled-components";
import ScrollContainer from 'react-indiana-drag-scroll';
import { getSpacing } from "stylesheetB2c";

export const Container = styled.div`
    padding: 16px;
`
export const ScrollableContainer = styled(ScrollContainer)`
    display: grid;
    grid-template-columns: repeat(2, auto);
    gap: 16px;
    overflow: auto;
    overflow-y: auto;
    height: 100vh;
    padding-bottom: ${getSpacing(100)};
`;